import {createSlice} from '@reduxjs/toolkit';
import {CLIENT_MAINTENANCE} from '../../constants/MicroServiceConstants';
import {httpPost} from '../../util/Rest';

const initialData = {
  status: null,
  Data: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'clientData',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchData: (state, action) => {
      state.Data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.Data = {};
    },
  },
});

export default slice.reducer;

// Actions

const {fetchData, fetchError, resetData} = slice.actions;

export const fetchSearchData = (value, searchAny) => {
  return (dispatch) => {
    httpPost(`${CLIENT_MAINTENANCE}/get/all/client`, {
      'parentClientName': searchAny.value === 'Parent Client' ? value : '',
      'clientName': searchAny.value === 'Client Name' ? value : '',
      'searchBy': (searchAny.value === 'Parent Client' || searchAny.value === 'Client Prefix') ? '' : searchAny.value,
      'searchTerm': '',
      'clientPrefix': searchAny.value === 'Client Prefix' ? value : '',
    })
      .then((data) => {
        if (data) {
          dispatch(fetchData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : ''));
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetSearchData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};

